import React from 'react';
import styles from './SystemDetails.module.css';

function ScreenSelector({ text, selected, onSelected }) {
  return selected ? (
    <div className={styles.screenSelectorContainer}>
      <button className={styles.selectedScreenSelector}>{text}</button>
      <div className={styles.selectedScreenSelectorLine} />
    </div>
  ) : (
    <div className={styles.screenSelectorContainer}>
      <button onClick={onSelected} className={styles.screenSelector}>
        {text}
      </button>
    </div>
  );
}

export default ScreenSelector;
